import { FC } from "react"
import { CardSpinProps } from "./models"
import { Spin } from "../../Spin"

export const CardSpin: FC<CardSpinProps> = (props) => {
  const { isFixed = true, isLoading, isSpin } = props

  return isSpin ? <Spin isFixed={isFixed} isLoading={isLoading} /> : null
}
